export default __webpack_public_path__ + "cfdb3a3.png";